/**
 * 菜单页
 */
import React, { FC, createContext } from 'react'
import { observer } from 'mobx-react'
import ProductTemplate from './ProductTemplate'
import './index.scss'

export const prodRecommendContent = createContext(null)

// interface
interface IProps extends IPage {
}

const MenuStyleDefault: FC<IProps> = () => {
  return (
    <div className='menu-style-default-container'>
      <ProductTemplate />
    </div>
  )
}

export default observer(MenuStyleDefault)
